export const GET_SUB_CATEGORY = "GET_SUB_CATEGORY";
export const GET_SUB_CATEGORY_FAIL = "GET_SUB_CATEGORY_FAIL";
